<template>
  <!-- Modal other files -->
  <div
    class="modal fade"
    id="other-file-ex"
    tabindex="-1"
    role="dialog"
    aria-labelledby="otherFileLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title" id="termsLabel">{{ $t('Diger dokumanlar header') }}</h4>
          <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
        </div>
        <div class="modal-body modal-body-min">
          <p>{{ $t('Diger dokumanlar text') }}</p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn_1" data-dismiss="modal">{{ $t('Kapat') }}</button>
        </div>
      </div>
      <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
  </div>
  <!-- /.modal -->
  <!-- Modal terms -->
</template>
<script>
export default {
  name: 'OtherDocumentModal',
};
</script>
